/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { Tooltip as CarbonTooltip } from 'carbon-addons-iot-react';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

const messages = defineMessages({ moreInformation: 'More information' });

const propTypes = {
  showTooltipOverText: PropTypes.bool,
  triggerId: PropTypes.string.isRequired,
};

const defaultProps = {
  showTooltipOverText: false,
};

/** This component adds an optional tooltip under the trigger text */
const Tooltip = ({
  intl: { formatMessage },
  triggerText, // eslint-disable-line react/prop-types
  children, // eslint-disable-line react/prop-types
  showTooltipOverText,
  triggerId,
  ...other
}) => (
  <CarbonTooltip
    iconDescription={formatMessage(messages.moreInformation)}
    triggerId={triggerId}
    triggerText={
      showTooltipOverText ? (
        <CarbonTooltip
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...other}
          triggerId={`${triggerId}-text`}
          showIcon={false}
          triggerText={triggerText}>
          {children}
        </CarbonTooltip>
      ) : (
        triggerText
      )
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...other}>
    {children}
  </CarbonTooltip>
);
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
export default injectIntl(Tooltip);
